const donationTier = (order) => {
  const amount = order.amount

  if (amount >= 2500) return "Diamond Tier"
  if (amount >= 1000) return "Platinum Tier"
  if (amount >= 500) return "Gold Tier"
  if (amount >= 150) return "Silver Tier"
  return "Bronze Tier"
}

export default donationTier
